import {Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {
	UpdateCustomFieldDropdownOptionsInput,
	UpdateCustomFieldDropdownOptionsMutation,
	UpdateCustomFieldDropdownOptionsMutation$rawResponse,
} from './__generated__/UpdateCustomFieldDropdownOptionsMutation.graphql';
import type {Disposable} from 'relay-runtime';

const mutation = graphql`
	mutation UpdateCustomFieldDropdownOptionsMutation($input: UpdateCustomFieldDropdownOptionsInput!) @raw_response_type {
		updateCustomFieldDropdownOptions(input: $input) {
			options {
				id
				displayName
			}
		}
	}
`;

function getOptimisticResponse(
	input: UpdateCustomFieldDropdownOptionsInput
): UpdateCustomFieldDropdownOptionsMutation$rawResponse {
	return {
		updateCustomFieldDropdownOptions: {
			options: input.options.map(option => ({
				id: option.id as string,
				displayName: option.displayName,
			})),
		},
	};
}
function commit(
	environment: Environment,
	input: MutationInput<UpdateCustomFieldDropdownOptionsInput>,
	onSuccess: RelayOnCompleted<UpdateCustomFieldDropdownOptionsMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinitionDropdownOptions - Updated');

	return trackAndCommitMutation<UpdateCustomFieldDropdownOptionsMutation>(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
